<template>
  <div class="setting-component">
    <div class="form-group">
      <custom-checkbox
        id="open-next-lot"
        v-model="autoLiveData.is_open_next_lot_auto"
        :label="trans('live.tabs.settings_network.auto_live_tab.labels.open_next_lot_checkbox')" />
    </div>
    <div class="form-group form-group-near">
      <select v-model="autoLiveData.open_next_lot_auto_mode" id="open-next-lot-duration" class="form-select-field">
        <option v-for="option in options" :value="option.value" :key="option.value">{{ option.label }}</option>
      </select>
    </div>
    <div class="form-group stage-b-item">
      <custom-checkbox
        id="change-bidding-status"
        v-model="autoLiveData.is_change_bidding_status_auto"
        :label="trans('live.tabs.settings_network.auto_live_tab.labels.change_bidding_status_checkbox')" />
    </div>
    <div class="form-group form-group-near stage-b-item">
      <select
        v-model="autoLiveData.change_bidding_status_mode"
        id="change-bidding-status-duration"
        class="form-select-field">
        <option v-for="option in options" :value="option.value" :key="option.value">{{ option.label }}</option>
      </select>
    </div>
    <div class="form-group stage-b-item">
      <custom-checkbox
        id="close_current_lot"
        v-model="autoLiveData.is_complete_current_lot_auto"
        :label="trans('live.tabs.settings_network.auto_live_tab.labels.close_current_lot')" />
    </div>
    <div class="form-group form-group-near stage-b-item">
      <select v-model="autoLiveData.complete_current_lot_mode" id="close-current-lot-duration" class="form-select-field">
        <option v-for="option in options" :value="option.value" :key="option.value">{{ option.label }}</option>
      </select>
    </div>
    <div class="action-block">
      <button class="btn btn-blue action" @click="save">
        {{ trans("live.tabs.settings_network.auto_live_tab.actions.save") }}
      </button>
      <div class="form-group stage-b-item">
        <label class="switch">
          <input v-model="isAutomatedLive" type="checkbox" />
          <span class="slider round"></span>
        </label>
        {{ trans("live.tabs.settings_network.auto_live_tab.actions.full_auto_auction") }}
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { trans } from "@/utils/trans";
  import CustomCheckbox from "@/components/_partials/widget/CustomCheckbox.vue";
  import { computed, ref, watch } from "vue";
  import apiClient from "@/services/api";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { useToast } from "primevue/usetoast";

  const auctionStore = useAuctionStore();
  const toast = useToast();

  const options = computed<{ value: number; label: string }[]>(() => {
    const result = [] as { value: number; label: string }[];
    for (let i = 1; i <= 300; i++) {
      result.push({
        value: i,
        label: `${i} sec`
      });
    }

    return result;
  });

  const autoLiveData = ref({
    is_open_next_lot_auto: auctionStore.liveSettings?.is_open_next_lot_auto == 1,
    is_change_bidding_status_auto: auctionStore.liveSettings?.is_change_bidding_status_auto == 1,
    is_complete_current_lot_auto: auctionStore.liveSettings?.is_complete_current_lot_auto == 1,
    open_next_lot_auto_mode: auctionStore.liveSettings?.open_next_lot_auto_mode,
    change_bidding_status_mode: auctionStore.liveSettings?.change_bidding_status_mode,
    complete_current_lot_mode: auctionStore.liveSettings?.complete_current_lot_mode
  });

  const isAutomatedLive = computed({
    get() {
      return (
        autoLiveData.value?.is_open_next_lot_auto &&
        autoLiveData.value?.is_change_bidding_status_auto &&
        autoLiveData.value?.is_complete_current_lot_auto
      );
    },
    set(newValue) {
      autoLiveData.value.is_open_next_lot_auto = newValue;
      autoLiveData.value.is_change_bidding_status_auto = newValue;
      autoLiveData.value.is_complete_current_lot_auto = newValue;
    }
  });

  watch(
    () => auctionStore.liveSettings,
    (newValue) => {
      autoLiveData.value.is_open_next_lot_auto = newValue?.is_open_next_lot_auto == 1;
      autoLiveData.value.is_change_bidding_status_auto = newValue?.is_change_bidding_status_auto == 1;
      autoLiveData.value.is_complete_current_lot_auto = newValue?.is_complete_current_lot_auto == 1;
      autoLiveData.value.open_next_lot_auto_mode = newValue?.open_next_lot_auto_mode;
      autoLiveData.value.change_bidding_status_mode = newValue?.change_bidding_status_mode;
      autoLiveData.value.complete_current_lot_mode = newValue?.complete_current_lot_mode;
    },
    { deep: true }
  );

  const save = () => {
    apiClient.put(auctionStore.routes["auctions.update_live_settings"], autoLiveData.value).then((response) => {
      if (response.data.status && response.data.settings) {
        auctionStore.$patch(response.data.settings);
      } else {
        console.log(response, response.data?.message);
      }
      toast.add({
        severity: response.data.status ? "success" : "error",
        summary: trans("live.toast." + (response.data.status ? "success" : "error")),
        detail: response.data.message || trans("live.toast.unknown_error"),
        life: 6000
      });
    });
  };
</script>
